// PasswordResetConfirmForm.js
// Form to set new password after clicking reset link


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PasswordResetConfirmForm.css';



import { useParams, useLocation } from 'react-router-dom';

const PasswordResetConfirmForm = () => {
  const { token } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const email = query.get('email');

  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  // Sync with dark mode from Navbar
  useEffect(() => {
    const updateThemeClass = () => {
      if (document.body.classList.contains('dark-mode')) {
        document.body.classList.add('dark');
        document.body.classList.remove('light');
      } else {
        document.body.classList.add('light');
        document.body.classList.remove('dark');
      }
    };
    updateThemeClass();
    window.addEventListener('darkModeChanged', updateThemeClass);
    return () => window.removeEventListener('darkModeChanged', updateThemeClass);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const apiUrl = process.env.REACT_APP_API_URL || '/api';
      await axios.post(`${apiUrl}/publicuser/password-reset`, { token, email, newPassword });
      setMessage('Password reset successful!');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password');
    }
  };

  return (
    <div className="password-reset-confirm-container">
      <div className="password-reset-confirm-card">
        <div className="password-reset-confirm-title">Set New Password</div>
        <div className="password-reset-confirm-desc">
          Please enter your new password below to complete the reset process.
        </div>
        <form className="password-reset-confirm-form" onSubmit={handleSubmit} autoComplete="off">
          <input
            name="newPassword"
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
          />
          <button type="submit">Reset Password</button>
        </form>
        {error && <div className="password-reset-confirm-error">{error}</div>}
        {message && <div className="password-reset-confirm-message">{message}</div>}
      </div>
    </div>
  );
};

export default PasswordResetConfirmForm;
